export const LIST_DROPPABLE_PREFIX = 'droppable-list-';
export const DEFAULT_CONTEXT_VALUE = {
    isInProvider: false,
    registerList: () => {
        throw new Error('[DragList] registerList must be used within a DragListProvider');
    },
    unregisterList: () => {
        throw new Error('[DragList] unregisterList must be used within a DragListProvider');
    },
    activeId: null,
    getItemId: () => {
        throw new Error('[DragList] getItemId must be used within a DragListProvider');
    }
};
